module.exports = __webpack_public_path__ + "static/media/e2.b4429379.png";